<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="display-1 mb-3">Currency Exchange Rate</h2>
    </v-flex>
    <v-flex xs12>
      <v-layout row wrap>
        <!-- delete dialog -->
        <v-flex xs12>
          <v-layout row justify-center>
            <v-dialog v-model="dialog" persistent max-width="550">
              <v-card>
                <v-card-title class="headline">Delete selected currency exchange rate?</v-card-title>
                <v-card-text
                  class="text-xs-left"
                >You are going to delete this selected currency exchange rate.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
                  <v-btn
                    color="accent"
                    flat
                    @click="deleteCurrencyById"
                    :loading="getLoading"
                    :disable="getLoading"
                  >delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-flex>

        <!-- New/Change dialog -->
        <v-flex xs12>
          <v-layout row justify-center>
            <v-dialog v-model="dialogForm" persistent max-width="600">
              <v-card>
                <v-card-title class="headline primary white--text">{{dialogTitle}} Currency Exchange</v-card-title>
                <v-container>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-flex xs12>
                          <v-select
                            v-bind:items="getAllCompanies"
                            v-model="currency.company_code"
                            label="Company code"
                            item-value="company_code"
                            :error-messages="errors.collect('company code')"
                            v-validate="'required'"
                            data-vv-name="company code"
                            required
                          >
                            <template
                              slot="selection"
                              slot-scope="data"
                            >{{ data.item.company_code }}</template>
                            <template
                              slot="item"
                              slot-scope="data"
                            >{{ data.item.company_code }} - {{ data.item.description }}</template>
                          </v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            :items="fromCurrency"
                            v-model="currency.from_currency_code"
                            label="From currency"
                            item-value="code"
                            readonly
                          >
                            <template slot="selection" slot-scope="data">{{ data.item.code }}</template>
                            <template
                              slot="item"
                              slot-scope="data"
                            >{{ data.item.code }} - {{ data.item.text }}</template>
                          </v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            :items="toCurrency"
                            v-model="currency.to_currency_code"
                            label="To currency"
                            item-value="code"
                            :error-messages="errors.collect('to currency')"
                            v-validate="'required'"
                            data-vv-name="currency"
                            required
                          >
                            <template slot="selection" slot-scope="data">{{ data.item.code }}</template>
                            <template
                              slot="item"
                              slot-scope="data"
                            >{{ data.item.code }} - {{ data.item.text }}</template>
                          </v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="currency.rate"
                            label="Rate"
                            :error-messages="errors.collect('rate')"
                            v-validate="'required'"
                            data-vv-name="rate"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row>
                            <v-flex xs3>
                                <v-subheader>Valid from</v-subheader>
                            </v-flex>
                            <v-flex xs9>
                               <date-picker v-model="currency.valid_from_date" format="YYYY-MM-DD" type="date" placeholder="Select date" value-type="format" style="width: 100%;"></date-picker>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row>
                            <v-flex xs3>
                               <v-subheader>Valid to</v-subheader>
                            </v-flex>
                            <v-flex xs9>
                               <date-picker v-model="currency.valid_to_date" format="YYYY-MM-DD" type="date" placeholder="Select date" value-type="format" style="width: 100%;"></date-picker>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="accent" flat @click="dialogForm = false">cancel</v-btn>
                  <v-btn
                    color="accent"
                    flat
                    @click="dialogFormSubmit"
                    :loading="getLoading"
                    :disable="getLoading"
                  >save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-card-title>
              <span class="title">Details</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card flat class="elevation-0">
              <v-card-title>
                <v-btn dark color="accent" @click="toggleDialogForm(null)">new</v-btn>
                <v-spacer></v-spacer>
                <v-text-field
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  v-model="search"
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :loading="getLoading"
                  :headers="headers"
                  :items="getCurrency"
                  :search="search"
                  class="elevation-0"
                  :rows-per-page-items="rowsPerPageItems"
                >
                  <template slot="headerCell" slot-scope="props">
                    <span>{{ props.header.text }}</span>
                  </template>
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">
                      <v-tooltip bottom>
                        <v-btn
                          flat
                          icon
                          @click="toggleDialogForm(props.item.id)"
                          color="accent lighten-1"
                          slot="activator"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <span>Change</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <v-btn
                          flat
                          icon
                          @click="toggleDialog(props.item.id)"
                          color="error lighten-1"
                          slot="activator"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>Delete</span>
                      </v-tooltip>
                    </td>
                    <td class="text-xs-left">{{ props.item.company_code}}</td>
                    <td class="text-xs-left">{{ props.item.base_currency_code}}</td>
                    <td class="text-xs-left">{{ props.item.to_currency_code}}</td>
                    <td class="text-xs-left">{{ props.item.rate}}</td>
                    <td class="text-xs-left">{{ props.item.valid_from_date | formatDate}}</td>
                    <td class="text-xs-left">{{ props.item.valid_to_date | formatDate}}</td>
                  </template>
                </v-data-table>
              </v-card-text>

              <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
                {{ text }}
                <v-btn flat dark @click.native="snackbar = false">
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-snackbar>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'currency',
  components: {
    DatePicker
  },
  data() {
    return {
      switch1: true,
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      dialogForm: false,
      dialogTitle: '',
      rowsPerPageItems: [10, 15, 20],
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Company code',
          align: 'left',
          value: 'company_code'
        },
        {
          text: 'From currency',
          align: 'left',
          value: 'base_currency_code'
        },
        {
          text: 'To currency',
          align: 'left',
          value: 'to_currency_code'
        },
        {
          text: 'Rate',
          align: 'left',
          value: 'rate'
        },
        {
          text: 'Valid from',
          align: 'left',
          value: 'valid_from_date'
        },
        {
          text: 'Valid end',
          align: 'left',
          value: 'valid_to_date'
        }
      ],
      items: [],
      currency: {
        id: '',
        company_code: '',
        from_currency_code: 'USD',
        to_currency_code: '',
        valid_from_date: new Date().toISOString().substr(0, 10),
        valid_to_date: '9999-12-31'
      },
      fromCurrency: [
        {
          code: 'USD',
          text: 'US Dollar'
        }
      ],
      toCurrency: [
        {
          code: 'AED',
          text: 'Emirati Dirham'
        },
        {
          code: 'AFN',
          text: 'Afghan Afghani'
        },
        {
          code: 'ALL',
          text: 'Albanian Lek'
        },
        {
          code: 'AMD',
          text: 'Armenian Dram'
        },
        {
          code: 'ANG',
          text: 'Dutch Guilder'
        },
        {
          code: 'AOA',
          text: 'Angolan Kwanza'
        },
        {
          code: 'ARS',
          text: 'Argentine Peso'
        },
        {
          code: 'AUD',
          text: 'Australian Dollar'
        },
        {
          code: 'AWG',
          text: 'Aruban or Dutch Guilder'
        },
        {
          code: 'AZN',
          text: 'Azerbaijan Manat'
        },
        {
          code: 'BAM',
          text: 'Bosnian Convertible Marka'
        },
        {
          code: 'BBD',
          text: 'Barbadian or Bajan Dollar'
        },
        {
          code: 'BDT',
          text: 'Bangladeshi Taka'
        },
        {
          code: 'BGN',
          text: 'Bulgarian Lev'
        },
        {
          code: 'BHD',
          text: 'Bahraini Dinar'
        },
        {
          code: 'BIF',
          text: 'Burundian Franc'
        },
        {
          code: 'BMD',
          text: 'Bermudian Dollar'
        },
        {
          code: 'BND',
          text: 'Bruneian Dollar'
        },
        {
          code: 'BOB',
          text: 'Bolivian Bolíviano'
        },
        {
          code: 'BRL',
          text: 'Brazilian Real'
        },
        {
          code: 'BSD',
          text: 'Bahamian Dollar'
        },
        {
          code: 'BTN',
          text: 'Bhutanese Ngultrum'
        },
        {
          code: 'BWP',
          text: 'Botswana Pula'
        },
        {
          code: 'BYN',
          text: 'Belarusian Ruble'
        },
        {
          code: 'BZD',
          text: 'Belizean Dollar'
        },
        {
          code: 'CAD',
          text: 'Canadian Dollar'
        },
        {
          code: 'CDF',
          text: 'Congolese Franc'
        },
        {
          code: 'CHF',
          text: 'Swiss Franc'
        },
        {
          code: 'CLP',
          text: 'Chilean Peso'
        },
        {
          code: 'CNY',
          text: 'Chinese Yuan Renminbi'
        },
        {
          code: 'COP',
          text: 'Colombian Peso'
        },
        {
          code: 'CRC',
          text: 'Costa Rican Colon'
        },
        {
          code: 'CUC',
          text: 'Cuban Convertible Peso'
        },
        {
          code: 'CUP',
          text: 'Cuban Peso'
        },
        {
          code: 'CVE',
          text: 'Cape Verdean Escudo'
        },
        {
          code: 'CZK',
          text: 'Czech Koruna'
        },
        {
          code: 'DJF',
          text: 'Djiboutian Franc'
        },
        {
          code: 'DKK',
          text: 'Danish Krone'
        },
        {
          code: 'DOP',
          text: 'Dominican Peso'
        },
        {
          code: 'DZD',
          text: 'Algerian Dinar'
        },
        {
          code: 'EGP',
          text: 'Egyptian Pound'
        },
        {
          code: 'ERN',
          text: 'Eritrean Nakfa'
        },
        {
          code: 'ETB',
          text: 'Ethiopian Birr'
        },
        {
          code: 'EUR',
          text: 'Euro'
        },
        {
          code: 'FJD',
          text: 'Fijian Dollar'
        },
        {
          code: 'FKP',
          text: 'Falkland Island Pound'
        },
        {
          code: 'GBP',
          text: 'British Pound'
        },
        {
          code: 'GEL',
          text: 'Georgian Lari'
        },
        {
          code: 'GGP',
          text: 'Guernsey Pound'
        },
        {
          code: 'GHS',
          text: 'Ghanaian Cedi'
        },
        {
          code: 'GIP',
          text: 'Gibraltar Pound'
        },
        {
          code: 'GMD',
          text: 'Gambian Dalasi'
        },
        {
          code: 'GNF',
          text: 'Guinean Franc'
        },
        {
          code: 'GTQ',
          text: 'Guatemalan Quetzal'
        },
        {
          code: 'GYD',
          text: 'Guyanese Dollar'
        },
        {
          code: 'HKD',
          text: 'Hong Kong Dollar'
        },
        {
          code: 'HNL',
          text: 'Honduran Lempira'
        },
        {
          code: 'HRK',
          text: 'Croatian Kuna'
        },
        {
          code: 'HTG',
          text: 'Haitian Gourde'
        },
        {
          code: 'HUF',
          text: 'Hungarian Forint'
        },
        {
          code: 'IDR',
          text: 'Indonesian Rupiah'
        },
        {
          code: 'ILS',
          text: 'Israeli Shekel'
        },
        {
          code: 'IMP',
          text: 'Isle of Man Pound'
        },
        {
          code: 'INR',
          text: 'Indian Rupee'
        },
        {
          code: 'IQD',
          text: 'Iraqi Dinar'
        },
        {
          code: 'IRR',
          text: 'Iranian Rial'
        },
        {
          code: 'ISK',
          text: 'Icelandic Krona'
        },
        {
          code: 'JEP',
          text: 'Jersey Pound'
        },
        {
          code: 'JMD',
          text: 'Jamaican Dollar'
        },
        {
          code: 'JOD',
          text: 'Jordanian Dinar'
        },
        {
          code: 'JPY',
          text: 'Japanese Yen'
        },
        {
          code: 'KES',
          text: 'Kenyan Shilling'
        },
        {
          code: 'KGS',
          text: 'Kyrgyzstani Som'
        },
        {
          code: 'KHR',
          text: 'Cambodian Riel'
        },
        {
          code: 'KMF',
          text: 'Comorian Franc'
        },
        {
          code: 'KPW',
          text: 'North Korean Won'
        },
        {
          code: 'KRW',
          text: 'South Korean Won'
        },
        {
          code: 'KWD',
          text: 'Kuwaiti Dinar'
        },
        {
          code: 'KYD',
          text: 'Caymanian Dollar'
        },
        {
          code: 'KZT',
          text: 'Kazakhstani Tenge'
        },
        {
          code: 'LAK',
          text: 'Lao Kip'
        },
        {
          code: 'LBP',
          text: 'Lebanese Pound'
        },
        {
          code: 'LKR',
          text: 'Sri Lankan Rupee'
        },
        {
          code: 'LRD',
          text: 'Liberian Dollar'
        },
        {
          code: 'LSL',
          text: 'Basotho Loti'
        },
        {
          code: 'LYD',
          text: 'Libyan Dinar'
        },
        {
          code: 'MAD',
          text: 'Moroccan Dirham'
        },
        {
          code: 'MDL',
          text: 'Moldovan Leu'
        },
        {
          code: 'MGA',
          text: 'Malagasy Ariary'
        },
        {
          code: 'MKD',
          text: 'Macedonian Denar'
        },
        {
          code: 'MMK',
          text: 'Burmese Kyat'
        },
        {
          code: 'MNT',
          text: 'Mongolian Tughrik'
        },
        {
          code: 'MOP',
          text: 'Macau Pataca'
        },
        {
          code: 'MRU',
          text: 'Mauritanian Ouguiya'
        },
        {
          code: 'MUR',
          text: 'Mauritian Rupee'
        },
        {
          code: 'MVR',
          text: 'Maldivian Rufiyaa'
        },
        {
          code: 'MWK',
          text: 'Malawian Kwacha'
        },
        {
          code: 'MXN',
          text: 'Mexican Peso'
        },
        {
          code: 'MYR',
          text: 'Malaysian Ringgit'
        },
        {
          code: 'MZN',
          text: 'Mozambican Metical'
        },
        {
          code: 'NAD',
          text: 'Namibian Dollar'
        },
        {
          code: 'NGN',
          text: 'Nigerian Naira'
        },
        {
          code: 'NIO',
          text: 'Nicaraguan Cordoba'
        },
        {
          code: 'NOK',
          text: 'Norwegian Krone'
        },
        {
          code: 'NPR',
          text: 'Nepalese Rupee'
        },
        {
          code: 'NZD',
          text: 'New Zealand Dollar'
        },
        {
          code: 'OMR',
          text: 'Omani Rial'
        },
        {
          code: 'PAB',
          text: 'Panamanian Balboa'
        },
        {
          code: 'PEN',
          text: 'Peruvian Sol'
        },
        {
          code: 'PGK',
          text: 'Papua New Guinean Kina'
        },
        {
          code: 'PHP',
          text: 'Philippine Peso'
        },
        {
          code: 'PKR',
          text: 'Pakistani Rupee'
        },
        {
          code: 'PLN',
          text: 'Polish Zloty'
        },
        {
          code: 'PYG',
          text: 'Paraguayan Guarani'
        },
        {
          code: 'QAR',
          text: 'Qatari Riyal'
        },
        {
          code: 'RON',
          text: 'Romanian Leu'
        },
        {
          code: 'RSD',
          text: 'Serbian Dinar'
        },
        {
          code: 'RUB',
          text: 'Russian Ruble'
        },
        {
          code: 'RWF',
          text: 'Rwandan Franc'
        },
        {
          code: 'SAR',
          text: 'Saudi Arabian Riyal'
        },
        {
          code: 'SBD',
          text: 'Solomon Islander Dollar'
        },
        {
          code: 'SCR',
          text: 'Seychellois Rupee'
        },
        {
          code: 'SDG',
          text: 'Sudanese Pound'
        },
        {
          code: 'SEK',
          text: 'Swedish Krona'
        },
        {
          code: 'SGD',
          text: 'Singapore Dollar'
        },
        {
          code: 'SHP',
          text: 'Saint Helenian Pound'
        },
        {
          code: 'SLL',
          text: 'Sierra Leonean Leone'
        },
        {
          code: 'SOS',
          text: 'Somali Shilling'
        },
        {
          code: 'SPL',
          text: 'Seborgan Luigino'
        },
        {
          code: 'SRD',
          text: 'Surinamese Dollar'
        },
        {
          code: 'STN',
          text: 'Sao Tomean Dobra'
        },
        {
          code: 'SVC',
          text: 'Salvadoran Colon'
        },
        {
          code: 'SYP',
          text: 'Syrian Pound'
        },
        {
          code: 'SZL',
          text: 'Swazi Lilangeni'
        },
        {
          code: 'THB',
          text: 'Thai Baht'
        },
        {
          code: 'TJS',
          text: 'Tajikistani Somoni'
        },
        {
          code: 'TMT',
          text: 'Turkmenistani Manat'
        },
        {
          code: 'TND',
          text: 'Tunisian Dinar'
        },
        {
          code: 'TOP',
          text: "Tongan Pa'anga"
        },
        {
          code: 'TRY',
          text: 'Turkish Lira'
        },
        {
          code: 'TTD',
          text: 'Trinidadian Dollar'
        },
        {
          code: 'TVD',
          text: 'Tuvaluan Dollar'
        },
        {
          code: 'TWD',
          text: 'Taiwan New Dollar'
        },
        {
          code: 'TZS',
          text: 'Tanzanian Shilling'
        },
        {
          code: 'UAH',
          text: 'Ukrainian Hryvnia'
        },
        {
          code: 'UGX',
          text: 'Ugandan Shilling'
        },
        {
          code: 'USD',
          text: 'US Dollar'
        },
        {
          code: 'UYU',
          text: 'Uruguayan Peso'
        },
        {
          code: 'UZS',
          text: 'Uzbekistani Som'
        },
        {
          code: 'VEF',
          text: 'Venezuelan Bolívar'
        },
        {
          code: 'VES',
          text: 'Venezuelan Bolívar'
        },
        {
          code: 'VND',
          text: 'Vietnamese Dong'
        },
        {
          code: 'VUV',
          text: 'Ni-Vanuatu Vatu'
        },
        {
          code: 'WST',
          text: 'Samoan Tala'
        },
        {
          code: 'XAF',
          text: 'Central African CFA Franc BEAC'
        },
        {
          code: 'XAG',
          text: 'Silver Ounce'
        },
        {
          code: 'XAU',
          text: 'Gold Ounce'
        },
        {
          code: 'XCD',
          text: 'East Caribbean Dollar'
        },
        {
          code: 'XDR',
          text: 'IMF Special Drawing Rights'
        },
        {
          code: 'XOF',
          text: 'CFA Franc'
        },
        {
          code: 'XPD',
          text: 'Palladium Ounce'
        },
        {
          code: 'XPF',
          text: 'CFP Franc'
        },
        {
          code: 'XPT',
          text: 'Platinum Ounce'
        },
        {
          code: 'YER',
          text: 'Yemeni Rial'
        },
        {
          code: 'ZAR',
          text: 'South African Rand'
        },
        {
          code: 'ZMW',
          text: 'Zambian Kwacha'
        },
        {
          code: 'ZWD',
          text: 'Zimbabwean Dollar'
        }
      ],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      validDateMenu: false,
      toDateMenu: false
    }
  },
  methods: {
    ...mapActions([
      'getAllCurrency',
      'deleteCurrency',
      'fetchAllCompanies',
      'addCurrency',
      'changeCurrency'
    ]),

    saveValidFromDate() {
      this.$refs.validDateMenu.save(this.currency.valid_from_date)
      this.validDateMenu = false
    },

    saveValidToDate() {
      this.$refs.toDateMenu.save(this.currency.valid_to_date)
      this.toDateMenu = false
    },
    toggleDialogForm: function(id) {
      if (id) {
        this.dialogTitle = 'Change'
        this.selectedId = id
        let temp = this.getCurrency.find(c => c.id === id)
        this.currency.id = temp.id
        this.currency.company_code = temp.company_code
        this.currency.to_currency_code = temp.to_currency_code
        this.currency.rate = temp.rate
        this.currency.valid_from_date = this.$options.filters.formatPickerDate(
          temp.valid_from_date
        )
        this.currency.valid_to_date = this.$options.filters.formatPickerDate(
          temp.valid_to_date
        )
      } else {
        this.dialogTitle = 'New'
        this.currency.company_code = ''
        this.currency.to_currency_code = ''
        this.currency.rate = ''
        this.currency.valid_from_date = new Date().toISOString().substr(0, 10)
        this.currency.valid_to_date = '9999-12-31'
      }
      this.dialogForm = true
    },

    toggleDialog: function(id) {
      this.selectedId = id
      this.dialog = true
    },

    dialogFormSubmit: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dialogTitle === 'Change') {
            this.updateCurrency()
          } else {
            this.newCurrency()
          }
        }
      })
    },

    newCurrency: function() {
      this.addCurrency(this.currency).then(() => {
        this.dialogForm = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Added successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },

    updateCurrency: function() {
      this.changeCurrency(this.currency).then(() => {
        this.dialogForm = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Changed successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },

    deleteCurrencyById() {
      this.deleteCurrency(this.selectedId).then(() => {
        this.dialog = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Deleted successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    }
  },
  mounted: function() {
    this.getAllCurrency()
    this.fetchAllCompanies()
  },
  computed: {
    ...mapGetters([
      'getCurrency',
      'getLoading',
      'getResponse',
      'getAllCompanies'
    ])
  }
}
</script>

<style scoped>
.input-group label {
  font-size: 13px !important;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/currency/Currency.vue